module.exports = __webpack_public_path__ + "static/media/oscarRojas.86e03892.jpg";